export default __webpack_public_path__ + "static/media/cms.fbf9f3b8.svg";